function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var MenuTemplate = require('./menu.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var MenuOverlay = /*#__PURE__*/function () {
  function MenuOverlay(app, mod, c1, c2, c3) {
    _classCallCheck(this, MenuOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod, true, false, false);
  }
  return _createClass(MenuOverlay, [{
    key: "hide",
    value: function hide() {
      this.overlay.hide();
    }
  }, {
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      //
      // pull GAME HUD over overlay
      //
      var overlay_zindex = parseInt(this.overlay.zIndex);
      var hud = document.getElementById('game-hud2');
      if (hud) {
        hud.style.zIndex = overlay_zindex + 1;
      }
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      //
      // push GAME HUD under overlay
      //
      var overlay_zindex = parseInt(this.overlay.zIndex);
      var hud = document.getElementById('game-hud2');
      if (hud) {
        hud.style.zIndex = overlay_zindex - 2;
      }
    }
  }, {
    key: "render",
    value: function render(player, faction) {
      var card = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var paths_self = this.mod;
      var c = {};
      if (card == '') {
        c.sr = 0;
        c.rp = 0;
      } else {
        var deck = paths_self.returnDeck();
        c = deck[card];
      }
      var menu_items = 1;
      var html = "\n\t      \t\t<div id=\"ops\" class=\"menu-option-container card menu_movement\">\n\t        \t\t<div class=\"menu-option-title\">Movement / Combat</div>\n\t      \t\t</div>\n\t      \t";
      if (c.sr && paths_self.canPlayStrategicRedeployment(faction)) {
        html += "\n\t\t\t<div id=\"sr\" class=\"menu-option-container card menu_redeployment\">\n\t        \t\t<div class=\"menu-option-title\">Strategic Redeployment</div>\n\t      \t\t</div>\n\t\t\t";
        menu_items++;
      }
      if (c.rp && paths_self.canPlayReinforcementPoints(faction)) {
        html += "\n\t      \t\t<div id=\"rp\" class=\"menu-option-container card menu_replacement\">\n\t        \t\t<div class=\"menu-option-title\">Replacement Points</div>\n\t      \t\t</div>\n\t\t\t";
        menu_items++;
      }
      var can_event_card = false;
      this.mod.game.state.player_turn_card_select = true;
      try {
        can_event_card = c.canEvent(this.mod, faction);
      } catch (err) {}
      if (c.cc) {
        can_event_card = false;
      }
      this.mod.game.state.player_turn_card_select = false;
      if (can_event_card) {
        html += "\n\t      \t\t\t<div id=\"event\" class=\"menu-option-container card menu_event\">\n\t        \t\t\t<div class=\"menu-option-title\">Card Event</div>\n\t      \t\t\t</div>\n\t  \t\t";
        menu_items++;
      }
      this.overlay.show(MenuTemplate(menu_items, html));
      this.pushHudUnderOverlay();
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {}
  }]);
}();
module.exports = MenuOverlay;